import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'
import BB8MainPage from './BB8MainPage'

export interface IBB8SummaryRowProps extends WithStyles {
  theme?: any
}

const styles = createStyles((theme: Theme) => ({
  container: {
    display: 'grid',
    gridGap: `${theme.spacing.unit * 3}px`,
    gridTemplateAreas: `"default default default default action"`,
    gridTemplateColumns: 'repeat(4, 1fr) minmax(130px, auto)',
    gridTemplateRows: '78px',
    width: '100%'
  },
  content: {
    padding: 0
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing.unit,
    padding: theme.spacing.unit,
    textAlign: 'center',
    whiteSpace: 'nowrap'
  }
}))

const BB8SummaryRow: React.SFC<IBB8SummaryRowProps> = ({ children, classes }) => {
  return (
    <BB8MainPage.Padded>
      <div className={classes.container}>{children}</div>
    </BB8MainPage.Padded>
  )
}

export default withStyles(styles)(BB8SummaryRow)
